import {useEffect, useRef} from 'react';

export const useScrollTabIntoView = (activeTabId, delay = 100) => {
    const containerRef = useRef(null);

    useEffect(() => {
        if (!activeTabId) return;

        const timeoutId = setTimeout(() => {
            const activeTabElement = document.getElementById(activeTabId);
            const container = containerRef.current;

            if (activeTabElement && container) {
                const containerRect = container.getBoundingClientRect();
                const tabRect = activeTabElement.getBoundingClientRect();

                // Calculate scroll position to center the tab
                const scrollLeft =
                    tabRect.left +
                    container.scrollLeft -
                    containerRect.left -
                    (containerRect.width / 2) +
                    (tabRect.width / 2);

                container.scrollTo({
                    left: Math.max(0, scrollLeft),
                    behavior: 'smooth'
                });
            }
        }, delay);

        return () => clearTimeout(timeoutId);
    }, [activeTabId, delay]);

    return containerRef;
};